module.exports = __webpack_public_path__ + "static/media/Plumbing.90b2f97e.jpg";